import React from 'react';
import '../../assets/styles/Terms.css';

interface TermsProps {
  onAccept: () => void;
  onCancel?: () => void;
  // Optionally, you can allow custom text for the terms.
  termsText?: string;
}

const Terms: React.FC<TermsProps> = ({ onAccept, onCancel, termsText }) => {
  return (
    <div className="terms-container">
      <h1>Terms &amp; Conditions</h1>
      {termsText && <p>{termsText}</p>}
      <div className="terms-content">
        <p>By using LavernAI, you agree to the following terms:</p>
        <ol>
          <li>
            <strong>Privacy and Data Collection:</strong> LavernAI will collect biometric data strictly for verification purposes.
          </li>
          <li>
            <strong>Monitoring Features:</strong> We monitor engagement to provide personalized learning experiences.
          </li>
          <li>
            <strong>Data Protection:</strong> Your data is encrypted and stored securely.
          </li>
          <li>
            <strong>Content Usage:</strong> Materials are provided for educational purposes only.
          </li>
          <li>
            <strong>Health Monitoring:</strong> Timely breaks are suggested to avoid eye strain.
          </li>
        </ol>
      </div>
      <div className="terms-actions">
        <button className="agree-button" onClick={onAccept}>
          I Agree
        </button>
        {onCancel && (
          <button className="cancel-button" onClick={onCancel}>
            Cancel
          </button>
        )}
      </div>
    </div>
  );
};

export default Terms;
